// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sensorsEquipmentsAreaContainer__mufbO {
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  padding: 20px;
  position: relative;
}

.sensorsEquipmentItemContainer__EcrS8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.row__qet3g {
  display: grid;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  width: 100%;
  gap: 10px;
}

.cell__BDObi {
  display: flex;
  gap: 40px;
  position: relative;
}

.temperature__m8mDz {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 5px;
  color: var(--tables-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  flex-wrap: wrap;
  justify-content: center;
}
.temperature__m8mDz .indicatorIcon__ZqkXc {
  fill: var(--tables-title-text);
}

.critical__smcIj {
  color: var(--legend-for-header-critical);
}
.critical__smcIj .indicatorIcon__ZqkXc {
  fill: var(--legend-for-header-critical);
}

.high__ApYcP {
  color: var(--legend-for-header-high);
}
.high__ApYcP .indicatorIcon__ZqkXc {
  fill: var(--legend-for-header-high);
}

.standard__jqzTT {
  color: var(--legend-for-header-standard);
}
.standard__jqzTT .indicatorIcon__ZqkXc {
  fill: var(--legend-for-header-standard);
}

.normal__Rval1 {
  color: var(--legend-for-header-no-ai);
}
.normal__Rval1 .indicatorIcon__ZqkXc {
  fill: var(--legend-for-header-no-ai);
}

.name__zLkyW {
  margin-bottom: 10px;
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
}

.runningTextContainer__cN0e2 {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
  color: var(--tables-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  gap: 5px;
}

.bathTempContainer__PMY9P {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.bathText__N3WKV {
  display: flex;
  flex-direction: column;
  color: var(--tables-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  gap: 5px;
}
@media (max-width: 1440px) {
  .bathText__N3WKV {
    display: none;
  }
}

.bathIcon__Z8zqr {
  display: flex;
  flex-direction: column;
  color: var(--tables-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  gap: 5px;
}

.bathTempsContainer__Xm70x {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.rightAngelConnectorIcon__AluJg {
  position: absolute;
  right: 0;
  top: 0;
}

.leftAngelConnectorIcon__JJPNu {
  position: absolute;
  right: 0;
  top: -50px;
  transform: scaleY(-1);
}

.smallAngelConnectorIcon__Jldsg {
  position: absolute;
  left: 0;
  top: -4px;
}

.angelEndIcon__RRMyz {
  position: absolute;
  left: 8px;
  bottom: 14px;
}

.straightConnectorIcon__soOgv {
  position: absolute;
  width: 100%;
  top: 0;
  display: block;
}

.thinStraightConnectorIcon__mSXjO {
  height: 6px;
  position: absolute;
  width: 100%;
  top: 0;
  display: block;
}

.firstStraightConnectorIcon__QUUu5 {
  width: 80%;
  right: 0;
}

.lastStraightConnectorIcon__Lvumg {
  width: 50%;
  left: 0;
}

.additionalTopPadding__fC0Yz {
  margin-top: 25px;
  margin-bottom: 25px;
}

.critical__smcIj [data-id=sensor-temperature] {
  fill: var(--legend-for-header-critical);
}

.high__ApYcP [data-id=sensor-temperature] {
  fill: var(--legend-for-header-high);
}

.standard__jqzTT [data-id=sensor-temperature] {
  fill: var(--legend-for-header-standard);
}

.normal__Rval1 [data-id=sensor-temperature] {
  fill: var(--legend-for-header-no-ai);
}

.rowReverse__qZRdL {
  flex-direction: row-reverse;
}

.bathM7TempContainer___9_1P {
  align-items: flex-start;
  justify-content: flex-end;
  margin-top: 55px;
}

.bathM1TempContainer__gLGiy .bathIcon__Z8zqr svg {
  transform: scaleX(-1);
}

.bathM7TempContainer___9_1P,
.bathM8TempContainer__hO8QE {
  align-items: flex-start;
  justify-content: flex-end;
  margin-top: 55px;
}

.downtimeIndicatorsCell__bLec7 {
  position: relative;
}

.downtimeIndicatorsWrapper__kWPjs {
  position: absolute;
  left: 76px;
  top: 70px;
}
@media (max-width: 1440px) {
  .downtimeIndicatorsWrapper__kWPjs {
    top: 0px;
  }
}

.angleDowntimeIcon__MdkTA {
  position: absolute;
  top: -435px;
  left: 60px;
}

.stretchItem__dt9tZ {
  justify-content: space-between;
}

.emptyContainer__xcLPw {
  max-width: 84px;
}

.additionalInfoContainer__NRH8B {
  color: var(--tables-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin-top: 54px;
}

.equipmentIconContainer__EHe3n {
  max-width: 84px;
}
.equipmentIconContainer__EHe3n svg {
  width: 100%;
  height: auto;
}

.hidden__xuBHW {
  visibility: hidden;
}

.assetLink__qqBX7 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;
  text-transform: uppercase;
  color: var(--buttons-text-secondary);
  position: relative;
}

.doubleArrowIcon__MqI9Z {
  position: absolute;
  right: -10px;
}
@media (max-width: 1600px) {
  .doubleArrowIcon__MqI9Z {
    display: none;
  }
}

.sensorLink__Z__OU {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsTemperature/components/SensorsEquipmentsArea/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kDAAA;EACA,qDAAA;EACA,2FACE;EAEF,aAAA;EACA,kBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;EACA,WAAA;EACA,SAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;AA3EF;AA6EE;EACE,8BAAA;AA3EJ;;AA+EA;EACE,wCAAA;AA5EF;AA6EE;EACE,uCAAA;AA3EJ;;AA+EA;EACE,oCAAA;AA5EF;AA6EE;EACE,mCAAA;AA3EJ;;AA+EA;EACE,wCAAA;AA5EF;AA6EE;EACE,uCAAA;AA3EJ;;AA+EA;EACE,qCAAA;AA5EF;AA6EE;EACE,oCAAA;AA3EJ;;AA+EA;EACE,mBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AA5EF;AA8EE;EAVF;IAWI,aAAA;EA3EF;AACF;;AA8EA;EACE,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,QAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,cAAA;AA3EF;;AA8EA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,cAAA;AA3EF;;AA8EA;EACE,UAAA;EACA,QAAA;AA3EF;;AA8EA;EACE,UAAA;EACA,OAAA;AA3EF;;AA8EA;EACE,gBAAA;EACA,mBAAA;AA3EF;;AA+EE;EACE,uCAAA;AA5EJ;;AAgFE;EACE,mCAAA;AA7EJ;;AAiFE;EACE,uCAAA;AA9EJ;;AAkFE;EACE,oCAAA;AA/EJ;;AAmFA;EACE,2BAAA;AAhFF;;AAmFA;EACE,uBAAA;EACA,yBAAA;EACA,gBAAA;AAhFF;;AAqFI;EACE,qBAAA;AAlFN;;AAuFA;;EAEE,uBAAA;EACA,yBAAA;EACA,gBAAA;AApFF;;AAuFA;EACE,kBAAA;AApFF;;AAuFA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AApFF;AAsFE;EALF;IAMI,QAAA;EAnFF;AACF;;AAsFA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAnFF;;AAsFA;EACE,8BAAA;AAnFF;;AAsFA;EACE,eAAA;AAnFF;;AAsFA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;AAnFF;;AAsFA;EACE,eAAA;AAnFF;AAqFE;EACE,WAAA;EACA,YAAA;AAnFJ;;AAuFA;EACE,kBAAA;AApFF;;AAuFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;AApFF;;AAuFA;EACE,kBAAA;EACA,YAAA;AApFF;AAsFE;EAJF;IAKI,aAAA;EAnFF;AACF;;AAsFA;EACE,qBAAA;AAnFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sensorsEquipmentsAreaContainer {\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  box-shadow:\n    0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n    0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  padding: 20px;\n  position: relative;\n}\n\n.sensorsEquipmentItemContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.row {\n  display: grid;\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  width: 100%;\n  gap: 10px;\n}\n\n.cell {\n  display: flex;\n  gap: 40px;\n  position: relative;\n}\n\n.temperature {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 5px;\n  color: var(--tables-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  .indicatorIcon {\n    fill: var(--tables-title-text);\n  }\n}\n\n.critical {\n  color: var(--legend-for-header-critical);\n  .indicatorIcon {\n    fill: var(--legend-for-header-critical);\n  }\n}\n\n.high {\n  color: var(--legend-for-header-high);\n  .indicatorIcon {\n    fill: var(--legend-for-header-high);\n  }\n}\n\n.standard {\n  color: var(--legend-for-header-standard);\n  .indicatorIcon {\n    fill: var(--legend-for-header-standard);\n  }\n}\n\n.normal {\n  color: var(--legend-for-header-no-ai);\n  .indicatorIcon {\n    fill: var(--legend-for-header-no-ai);\n  }\n}\n\n.name {\n  margin-bottom: 10px;\n  color: var(--tables-primary-row-text-main);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.runningTextContainer {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-end;\n  color: var(--tables-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  gap: 5px;\n}\n\n.bathTempContainer {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.bathText {\n  display: flex;\n  flex-direction: column;\n  color: var(--tables-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  gap: 5px;\n\n  @media (max-width: 1440px) {\n    display: none;\n  }\n}\n\n.bathIcon {\n  display: flex;\n  flex-direction: column;\n  color: var(--tables-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  gap: 5px;\n}\n\n.bathTempsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n.rightAngelConnectorIcon {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.leftAngelConnectorIcon {\n  position: absolute;\n  right: 0;\n  top: -50px;\n  transform: scaleY(-1);\n}\n\n.smallAngelConnectorIcon {\n  position: absolute;\n  left: 0;\n  top: -4px;\n}\n\n.angelEndIcon {\n  position: absolute;\n  left: 8px;\n  bottom: 14px;\n}\n\n.straightConnectorIcon {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  display: block;\n}\n\n.thinStraightConnectorIcon {\n  height: 6px;\n  position: absolute;\n  width: 100%;\n  top: 0;\n  display: block;\n}\n\n.firstStraightConnectorIcon {\n  width: 80%;\n  right: 0;\n}\n\n.lastStraightConnectorIcon {\n  width: 50%;\n  left: 0;\n}\n\n.additionalTopPadding {\n  margin-top: 25px;\n  margin-bottom: 25px;\n}\n\n.critical {\n  [data-id='sensor-temperature'] {\n    fill: var(--legend-for-header-critical);\n  }\n}\n.high {\n  [data-id='sensor-temperature'] {\n    fill: var(--legend-for-header-high);\n  }\n}\n.standard {\n  [data-id='sensor-temperature'] {\n    fill: var(--legend-for-header-standard);\n  }\n}\n.normal {\n  [data-id='sensor-temperature'] {\n    fill: var(--legend-for-header-no-ai);\n  }\n}\n\n.rowReverse {\n  flex-direction: row-reverse;\n}\n\n.bathM7TempContainer {\n  align-items: flex-start;\n  justify-content: flex-end;\n  margin-top: 55px;\n}\n\n.bathM1TempContainer {\n  .bathIcon {\n    svg {\n      transform: scaleX(-1);\n    }\n  }\n}\n\n.bathM7TempContainer,\n.bathM8TempContainer {\n  align-items: flex-start;\n  justify-content: flex-end;\n  margin-top: 55px;\n}\n\n.downtimeIndicatorsCell {\n  position: relative;\n}\n\n.downtimeIndicatorsWrapper {\n  position: absolute;\n  left: 76px;\n  top: 70px;\n\n  @media (max-width: 1440px) {\n    top: 0px;\n  }\n}\n\n.angleDowntimeIcon {\n  position: absolute;\n  top: -435px;\n  left: 60px;\n}\n\n.stretchItem {\n  justify-content: space-between;\n}\n\n.emptyContainer {\n  max-width: 84px;\n}\n\n.additionalInfoContainer {\n  color: var(--tables-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n  margin-top: 54px;\n}\n\n.equipmentIconContainer {\n  max-width: 84px;\n\n  svg {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.assetLink {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-decoration: none;\n  text-transform: uppercase;\n  color: var(--buttons-text-secondary);\n  position: relative;\n}\n\n.doubleArrowIcon {\n  position: absolute;\n  right: -10px;\n\n  @media (max-width: 1600px) {\n    display: none;\n  }\n}\n\n.sensorLink {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensorsEquipmentsAreaContainer": `sensorsEquipmentsAreaContainer__mufbO`,
	"sensorsEquipmentItemContainer": `sensorsEquipmentItemContainer__EcrS8`,
	"row": `row__qet3g`,
	"cell": `cell__BDObi`,
	"temperature": `temperature__m8mDz`,
	"indicatorIcon": `indicatorIcon__ZqkXc`,
	"critical": `critical__smcIj`,
	"high": `high__ApYcP`,
	"standard": `standard__jqzTT`,
	"normal": `normal__Rval1`,
	"name": `name__zLkyW`,
	"runningTextContainer": `runningTextContainer__cN0e2`,
	"bathTempContainer": `bathTempContainer__PMY9P`,
	"bathText": `bathText__N3WKV`,
	"bathIcon": `bathIcon__Z8zqr`,
	"bathTempsContainer": `bathTempsContainer__Xm70x`,
	"rightAngelConnectorIcon": `rightAngelConnectorIcon__AluJg`,
	"leftAngelConnectorIcon": `leftAngelConnectorIcon__JJPNu`,
	"smallAngelConnectorIcon": `smallAngelConnectorIcon__Jldsg`,
	"angelEndIcon": `angelEndIcon__RRMyz`,
	"straightConnectorIcon": `straightConnectorIcon__soOgv`,
	"thinStraightConnectorIcon": `thinStraightConnectorIcon__mSXjO`,
	"firstStraightConnectorIcon": `firstStraightConnectorIcon__QUUu5`,
	"lastStraightConnectorIcon": `lastStraightConnectorIcon__Lvumg`,
	"additionalTopPadding": `additionalTopPadding__fC0Yz`,
	"rowReverse": `rowReverse__qZRdL`,
	"bathM7TempContainer": `bathM7TempContainer___9_1P`,
	"bathM1TempContainer": `bathM1TempContainer__gLGiy`,
	"bathM8TempContainer": `bathM8TempContainer__hO8QE`,
	"downtimeIndicatorsCell": `downtimeIndicatorsCell__bLec7`,
	"downtimeIndicatorsWrapper": `downtimeIndicatorsWrapper__kWPjs`,
	"angleDowntimeIcon": `angleDowntimeIcon__MdkTA`,
	"stretchItem": `stretchItem__dt9tZ`,
	"emptyContainer": `emptyContainer__xcLPw`,
	"additionalInfoContainer": `additionalInfoContainer__NRH8B`,
	"equipmentIconContainer": `equipmentIconContainer__EHe3n`,
	"hidden": `hidden__xuBHW`,
	"assetLink": `assetLink__qqBX7`,
	"doubleArrowIcon": `doubleArrowIcon__MqI9Z`,
	"sensorLink": `sensorLink__Z__OU`
};
module.exports = ___CSS_LOADER_EXPORT___;
